import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useServer } from "@/lib/server-context";
import { UserPlus, Copy } from "lucide-react";
import { toast } from "sonner";
import EmptyServer from "@/components/dashboard/EmptyServer";

export default function InviteTrackerPanel() {
  const { active } = useServer();
  const [invites, setInvites] = useState([]);

  useEffect(() => {
    if (!active?.id || !active.bot_present) return;
    api.get(`/features/invites/${active.id}`).then((r) => setInvites(r.data));
  }, [active?.id, active?.bot_present]);

  if (!active) return <EmptyServer />;
  if (!active.bot_present) return <EmptyServer needsBot />;

  return (
    <div data-testid="invites-panel" className="space-y-8">
      <div>
        <div className="overline mb-2"><UserPlus className="inline w-4 h-4 mr-2 -mt-1" />SERVER MANAGEMENT</div>
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tight">Invite Tracker</h1>
        <p className="text-zinc-400 mt-2">All active server invites + who created them. Track recruitment.</p>
      </div>

      <div className="tactical-card p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading uppercase text-lg">Active Invites ({invites.length})</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="invites-table">
            <thead className="text-zinc-500">
              <tr className="border-b border-brand-line">
                <th className="text-left py-2 overline">CODE</th>
                <th className="text-left py-2 overline">CHANNEL</th>
                <th className="text-left py-2 overline">INVITER</th>
                <th className="text-right py-2 overline">USES</th>
                <th className="text-right py-2 overline">MAX</th>
                <th className="text-right py-2 overline pr-2"></th>
              </tr>
            </thead>
            <tbody>
              {invites.length === 0 && <tr><td colSpan="6" className="py-8 text-center text-zinc-500 font-mono-tabular">No active invites</td></tr>}
              {invites.map((inv) => (
                <tr key={inv.code} className="border-b border-brand-line/40" data-testid={`inv-${inv.code}`}>
                  <td className="py-2 font-mono-tabular text-brand-orange">{inv.code}</td>
                  <td className="py-2">#{inv.channel}</td>
                  <td className="py-2">{inv.inviter}</td>
                  <td className="py-2 text-right font-mono-tabular">{inv.uses}</td>
                  <td className="py-2 text-right font-mono-tabular text-zinc-500">{inv.max_uses || "∞"}</td>
                  <td className="py-2 text-right pr-2">
                    <button onClick={() => { navigator.clipboard.writeText(inv.url); toast("Copied"); }} className="text-zinc-400 hover:text-brand-orange"><Copy className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
